<template>
  <div>
    <!-- 运行明细 -->
    <!-- 查询、 -->
    <div style="text-align:right">
      <el-form :inline="true" class="form">
        <el-form-item :label="$t('time.timeQuery')">
          <el-date-picker
            v-model="date" 
            :size="size"
            type="daterange"
            :placeholder="$t('vehicleInfo.selectusedate')"
            :picker-options="datePickerOptions"
          ></el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-time-picker 
            v-model="timeValue" 
            :size="size"
            :picker-options="{selectableRange: '00:00:00 - 23:59:59',}" 
            is-range 
            :clearable="false" 
            style="width: 180px" 
            value-format="HH:mm:ss"
            format="HH:mm:ss"
            placeholder="请选择时间"></el-time-picker>
        </el-form-item>
        <el-form-item>
          <el-button 
            type="primary" 
            
            :size="size"
            style="margin-left:8px;"
            @click="handleQuery"
          >{{ $t("public.query")}}</el-button>
        </el-form-item>
        <el-form-item>
          <el-button 
            :size="size"
            type="primary"  plain 
            style="margin-left:10px"
            @click="download"
            :loading="downloading"
          >{{ $t("public.export")}}</el-button>
        </el-form-item>
      </el-form>
      <!-- <datetimerange></datetimerange> -->
      
    </div>
    <!-- 表格 -->
    <div class="page_container_a">
      <el-table :data="dataList" border :size="size" :span-method="objectSpanMethod" v-loading="loading">
        <el-table-column :label="$t('runState.carNo')" align="center" min-width="85" prop="carNo" fixed="left"></el-table-column>
        <el-table-column :label="$t('runState.statDate')" align="center" min-width="110" prop="statDate" fixed="left"></el-table-column>
        <el-table-column :label="$t('runState.ACCOnTime')" align="center" min-width="110" prop="ACCOnTime" fixed="left"></el-table-column>
        <el-table-column :label="$t('runState.BeginTime')" align="center" min-width="110" prop="BeginTime"></el-table-column>
        <el-table-column :label="$t('runState.EndTime')" align="center" min-width="110" prop="EndTime"></el-table-column>
        <el-table-column :label="$t('runState.ACCOffTime')" align="center" min-width="110" prop="ACCOffTime"></el-table-column>
        <el-table-column :label="$t('runState.runDuration')" align="center" min-width="120" prop="runDuration">
          <template slot-scope="scope">{{fixed2(scope.row.runDuration)}}</template>
        </el-table-column>
        <el-table-column :label="$t('runState.driveDuration')" align="center" min-width="120" prop="driveDuration">
          <template slot-scope="scope">{{fixed2(scope.row.driveDuration)}}</template>
        </el-table-column>
        <el-table-column :label="$t('runState.idleDuration')" align="center" min-width="120" prop="idleDuration">
          <template slot-scope="scope">{{fixed2(scope.row.idleDuration)}}</template>
        </el-table-column>
        <el-table-column :label="$t('runState.airDuration')" align="center" min-width="150" prop="airDuration">
          <template slot-scope="scope">{{fixed2(scope.row.airDuration)}}</template>
        </el-table-column>
        <el-table-column :label="$t('runState.heaterDuration')" align="center" min-width="160" prop="heaterDuretion">
          <template slot-scope="scope">{{fixed2(scope.row.heaterDuretion)}}</template>
        </el-table-column>
        <el-table-column :label="$t('runState.minSpeed')" align="center" min-width="150" prop="minSpeed"></el-table-column>
        <el-table-column :label="$t('runState.maxSpeed')" align="center" min-width="150" prop="maxSpeed"></el-table-column>
        <el-table-column :label="$t('runState.avgSpeed')" align="center" min-width="150" prop="avgSpeed"></el-table-column>
        <el-table-column :label="$t('runState.mileage')" align="center" min-width="120" prop="mileage"></el-table-column>
        <el-table-column :label="$t('runState.oilConsume')" align="center" min-width="110" prop="oilConsume"></el-table-column>
        <el-table-column :label="$t('runState.perOilConsume')" align="center" min-width="110" prop="perOilConsume"></el-table-column>
        <el-table-column :label="$t('runState.elecConsume')" align="center" min-width="110" prop="elecConsume"></el-table-column>
        <el-table-column :label="$t('runState.perElecConsume')" align="center" min-width="110" prop="perElecConsume"></el-table-column>
      </el-table>
    </div>
    <div style="text-align: right ;margin-top:8px" class="pagination" v-show="total>0" >  <!--  -->
      <kl-pagination
        :total="total"
        :currentPage="currentPage"
        @current-change="currentchange"
      ></kl-pagination>
      </div>
  </div>
</template>
<script>
import datetimerange from '@/views/statistics/operationalData/components/datetimerange'
import language from '@/utils/getLanguageId'
import { mapState } from "vuex";
export default {
  props:{
    size:{
      type: String,
    },
    isClicked:{
      type: Boolean,
      default:false,
    }
  },
  components:{datetimerange},
  data(){
    return{
      downloading:false,
      vehicles:'',
      pageSize:10,
      currentPage:1,
      total:0,
      loading:false,
      needMergeArr: ["carNo", "statDate"], 
      rowMergeArrs: [],
      dataList:[],
      date:[new Date(new Date().getTime() - 1 * 24 * 60 * 60 * 1000),new Date(new Date().getTime() - 1 * 24 * 60 * 60 * 1000)],
      timeValue:[new Date(2023, 4, 1, 0, 0, 0),
          new Date(2023, 4, 1, 23, 59, 59)],
      datePickerOptions: {
        disabledDate(date) {
            return date > new Date(new Date().getTime() -  24 * 60 * 60 * 1000)
        }
      },
      LanguageId:1,
    }
  },
  computed:{
    ...mapState({
        operator: (state) => state.user.operator,
        selectedVehicles: state => state.app.vehicles.selectedVehicles,
    }),
  },
  watch:{
  },
  methods:{
    getSelectedVehicles(){
      this.vehicles = "";
      for(let k = 0; k < this.selectedVehicles.length; k++){
        if(this.selectedVehicles[k].treeLevel == 5){
          this.vehicles = this.vehicles + this.selectedVehicles[k].nodeValue + ",";
        }
      }
      return this.vehicles.substring(0,this.vehicles.length-1);
    },
    fixed2(val){
      if(val == 0 || val == null || val == undefined || val == ""){
        return 0;
      }
      return val.toFixed(2)
    },
    currentchange(val) {
      this.currentPage = val;
      this.getList();
    },
    getList(){
      this.loading = true;
      let beginTime,endTime;
      beginTime = this.moment(this.timeValue[0]).format("yyyy-MM-DD HH:mm:ss") == "Invalid date" 
                    ? this.timeValue[0] : this.moment(this.timeValue[0]).format("yyyy-MM-DD HH:mm:ss").split(" ")[1];
      endTime = this.moment(this.timeValue[1]).format("yyyy-MM-DD HH:mm:ss") == "Invalid date" 
                    ? this.timeValue[1] : this.moment(this.timeValue[1]).format("yyyy-MM-DD HH:mm:ss").split(" ")[1];

      this.$api.runStateDetailInfo({
        beginDate: this.moment(this.date[0]).format("YYYY-MM-DD"),
        endDate: this.moment(this.date[1]).format("YYYY-MM-DD"),
        beginTime: beginTime,
        endTime: endTime,
        OperatorID: this.operator.OperatorId + "",
        vehicles: this.vehicles,
        PageNo: this.currentPage,
        PageSize: 10,
        IsExport: 0, // 0是查询 1是下载
        Language: this.LanguageId,
      })
      .then((res)=>{
        if(res && res.code == 200){
          this.dataList = res.data;
          this.total = res.count;
          this.loading = false;
        }
      })
      .catch((e)=>{
        this.loading = false;
        this.dataList = [];
        this.total = 0;
      })
    },
    handleQuery(){
      this.vehicles = this.getSelectedVehicles();
      if(this.date == "" || this.date == null || this.date == undefined){
        this.$message({
          message: this.$t("runState.select_search_date"),//'请选择查询时间',
          type: 'warning'
        });
        return ;
      }
      this.currentPage = 1;
      this.getList();
    },
    download(){
      this.vehicles = this.getSelectedVehicles();
      var that = this;
      that.downloading = true;
      let beginTime,endTime;
      beginTime = this.moment(this.timeValue[0]).format("yyyy-MM-DD HH:mm:ss") == "Invalid date" 
                    ? this.timeValue[0] : this.moment(this.timeValue[0]).format("yyyy-MM-DD HH:mm:ss").split(" ")[1];
      endTime = this.moment(this.timeValue[1]).format("yyyy-MM-DD HH:mm:ss") == "Invalid date" 
                    ? this.timeValue[1] : this.moment(this.timeValue[1]).format("yyyy-MM-DD HH:mm:ss").split(" ")[1];
      this.$api.
        downRunStateDetailInfo({
          beginDate: this.moment(this.date[0]).format("yyyy-MM-DD"),
          endDate: this.moment(this.date[1]).format("yyyy-MM-DD"),
          beginTime: beginTime,
          endTime: endTime,
          OperatorID: this.operator.OperatorId + "",
          vehicles: this.vehicles,
          IsExport: 1, // 0是查询 1是下载
          Language: this.LanguageId,
        })
        .then((res) => {
          let blob = new Blob([res], {
            type: "application/vnd.ms-excel;charset=utf-8",
          }); // 重点代码
          let a = document.createElement("a");
          a.href = window.URL.createObjectURL(blob);
          a.setAttribute(
            "download",
            that.$t("runState.operDeal")+that.$t("public.download") + `_${that.timestampToTime(new Date().getTime())}.xlsx`
          ); // 表名，自定义
          a.click(); // 执行下载
          window.URL.revokeObjectURL(blob); // 释放ur
          that.downloading = false;
        })
        .catch((error) => {
          console.error("下载失败", error);
          that.downloading = false;
        });
    },
    //时间戳转换为日期格式
    timestampToTime(timestamp) {
      var date = new Date(timestamp); //时间数为10位篇*1000，时间数为13位的话不需乘1000
      var Y = date.getFullYear();
      var M =
        date.getMonth() + 1 < 10
          ? "0" + (date.getMonth() + 1)
          : date.getMonth() + 1;
      var D = date.getDate();
      var h = date.getHours();
      var m = date.getMinutes();
      var s = date.getSeconds();
      return Y + M + D + h + m + s;
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map(v => filterVal.map(j => {
        if(j == "runDuration"){
          return this.fixed2(v[j]);
        }else if(j == "driveDuration"){
          return this.fixed2(v[j]);
        }else if(j == "idleDuration"){
          return this.fixed2(v[j]);
        }else if(j == "airDuration"){
          return this.fixed2(v[j]);
        }else if(j == "heaterDuretion"){
          return this.fixed2(v[j]);
        }else {
          return v[j];
        }
      }))
    },
    
    objectSpanMethod({ row, column, rowIndex, columnIndex}) {

      // 获取表格数据
      const data = this.dataList;
      // 合并 carNo 列
      if (columnIndex === 0) {
        if (rowIndex > 0 && row.carNo === data[rowIndex - 1].carNo) {
          return { rowspan: 0, colspan: 0 };  // 合并当前和上一行的 carNo
        } else {
          let rowspan = 1;
          for (let i = rowIndex + 1; i < data.length; i++) {
            if (data[i].carNo === row.carNo) {
              rowspan++;
            } else {
              break;
            }
          }
          return {
            rowspan: rowspan, // 合并的行数
            colspan: 1 // carNo 列合并
          };
        }
      }

      // 合并 statDate 列
      if (columnIndex === 1) {
        if (rowIndex > 0 && row.statDate === data[rowIndex - 1].statDate && row.carNo === data[rowIndex - 1].carNo) {
          return { rowspan: 0, colspan: 0 };  // 合并当前和上一行的 statDate
        } else {
          let rowspan = 1;
          for (let i = rowIndex + 1; i < data.length; i++) {
            if (data[i].carNo === row.carNo && data[i].statDate === row.statDate) {
              rowspan++;
            } else {
              break;
            }
          }
          return {
            rowspan: rowspan, // 合并的行数
            colspan: 1 // statDate 列合并
          };
        }
      }

      // 其他列的处理
      return {
        rowspan: 1,
        colspan: 1
      };
    },
  },
  created(){
    
    },
  mounted(){
    // this.getList();
    this.LanguageId = language(this.$store.getters.locale)
    this.handleQuery();
  }
}
</script>
<style lang="scss" scoped>
.form  {
  ::v-deep .el-form-item {
      margin-bottom: 0px !important;
  }
}
.page_container_a {
    margin-top: 10px;

    ::v-deep .el-table tr {
        background: rgb(244, 248, 255);
    }

    ::v-deep .el-table {
        background: rgb(244, 248, 255);
    }

    ::v-deep .el-table td {
        background: rgb(244, 248, 255);
    }
} 
</style>